import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const AgendasPage = lazy(() =>
	import('./AgendasPage').then(({ AgendasPage }) => ({
		default: AgendasPage,
	}))
);

export const getAgendasRoutes = (): RouteObject[] => [
	{
		path: getPagePartSlug('kde-o-mne-stat-vede-udaje'),
		element: (
			<AuthorizedRoute>
				<AgendasPage />
			</AuthorizedRoute>
		),
	},
];
